// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"178":"4562170d","457":"f60c2f1d"}[chunkId] + ".chunk.css";
};